module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/finance/expenditure/expenditure-grid/expenditure-grid.component.css
// module id = ./src/app/finance/expenditure/expenditure-grid/expenditure-grid.component.css
// module chunks = main